<template>
  <div class="app-bar">
    <nav class="bg-gray-800 py-4">
      <div class="w-full md:w-10/12 mx-auto text-white flex justify-between px-4 md:px-0">
        <div class="flex items-center">
          <router-link to="/" class="hover:text-white">
            <img class="h-12" src="@/assets/logo.png" alt="">
          </router-link>
          <!-- <div v-if="$store.getters.showNav" class="pl-4">
            <router-link
              to="/"
              class="mx-1 px-4 py-2 rounded font-bold text-sm border-2 border-transparent hover:border-gray-700 hover:text-white"
            >Subscription</router-link>
            <router-link
              to="/payments"
              class="mx-1 px-4 py-2 rounded font-bold text-sm border-2 border-transparent hover:border-gray-700 hover:text-white"
            >Payments</router-link>
            <router-link
              to="/profile"
              class="mx-1 px-4 py-2 rounded font-bold text-sm border-2 border-transparent hover:border-gray-700 hover:text-white"
            >Profile</router-link>
          </div>-->
        </div>
        <div class="flex items-center">
          <!-- <div v-if="$store.state.loggedInUser" class="relative flex">
            <button
              @click="showNotificationDropdown = !showNotificationDropdown"
              class="relative mx-6 p-2 border-2 border-transparent rounded hover:border-gray-700 hover:text-white"
            >
              <svg class="h-6 fill-current" viewBox="0 0 24 24">
                <path
                  d="M16,17H7V10.5C7,8 9,6 11.5,6C14,6 16,8 16,10.5M18,16V10.5C18,7.43 15.86,4.86 13,4.18V3.5A1.5,1.5 0 0,0 11.5,2A1.5,1.5 0 0,0 10,3.5V4.18C7.13,4.86 5,7.43 5,10.5V16L3,18V19H20V18M11.5,22A2,2 0 0,0 13.5,20H9.5A2,2 0 0,0 11.5,22Z"
                />
              </svg>
            </button>
            <div
              v-if="showNotificationDropdown"
              @click="showNotificationDropdown = false"
              class="fixed inset-0 z-40"
            ></div>
            <div
              v-if="showNotificationDropdown"
              class="absolute flex flex-col right-0 bg-white text-black z-50 mt-12 w-64 max-h-50 rounded shadow overflow-y-scroll"
            >
              <article class="flex items-start hover:bg-gray-100 p-4 rounded">
                <div class="flex w-2/12 pr-4">
                  <svg class="fill-current w-full text-gray-500" viewBox="0 0 24 24">
                    <path
                      d="M12,8H4A2,2 0 0,0 2,10V14A2,2 0 0,0 4,16H5V20A1,1 0 0,0 6,21H8A1,1 0 0,0 9,20V16H12L17,20V4L12,8M21.5,12C21.5,13.71 20.54,15.26 19,16V8C20.53,8.75 21.5,10.3 21.5,12Z"
                    />
                  </svg>
                </div>
                <div class="w-10/12 flex flex-col">
                  <h3 class="text-gray-800 font-bold">Notification! You need to read this!!</h3>
                  <span class="text-gray-600 text-sm mb-2">2 months ago</span>
                  <p
                    class="text-gray-800"
                  >Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis distinctio delectus eius nostrum incidunt alias saepe, praesentium nam? Ea possimus odio tempora a culpa accusantium explicabo consequatur iste. Repellat, tenetur.</p>
                </div>
              </article>
            </div>
          </div> -->
          <router-link
            v-if="!$store.getters.isLoggedIn"
            to="/login"
            class="bg-transparent border-transparent hover:border-gray-700 hover:text-white border-2 p-2 rounded inline-flex items-center justify-center"
          >
            <svg class="h-5 fill-current mr-1" viewBox="0 0 24 24">
              <path
                d="M12,17C10.89,17 10,16.1 10,15C10,13.89 10.89,13 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M18,20V10H6V20H18M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V10C4,8.89 4.89,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z"
              />
            </svg>
            <span>Log In</span>
          </router-link>
          <div v-if="$store.getters.isLoggedIn" class="relative flex">
            <button
              class="relative hover:border-gray-700 border-4 border-transparent rounded-full"
              @click="showAccountDropdown = !showAccountDropdown"
            >
              <div>
                <img class="rounded-full h-10" :src="$store.getters.tokenInfo.picture" alt />
              </div>
            </button>
            <div
              v-if="showAccountDropdown"
              @click="showAccountDropdown = false"
              class="fixed inset-0 z-40"
            ></div>
            <div
              v-if="showAccountDropdown"
              class="absolute right-0 bg-white text-black z-50 w-56 mt-12 rounded p-4 shadow"
            >
              <h3 class="text-gray-800 font-bold text-lg">{{ $store.state.loggedInUser.name }}</h3>
              <h3 class="text-gray-500 font-bold text-sm mb-4">{{ $store.state.loggedInUser.email }}</h3>
              <div class="my-4 flex flex-col">
                <button
                  @click="goToProfile"
                  class="w-full p-2 rounded hover:bg-gray-200 flex items-center justify-between"
                >
                  <div class="flex items-center">
                    <svg class="fill-current h-5 w-5 mr-2" viewBox="0 0 24 24">
                      <path
                        d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"
                      />
                    </svg>
                    <span>Account</span>
                  </div>
                  <svg class="fill-current h-4 ml-4" viewBox="0 0 24 24">
                    <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
                  </svg>
                </button>
                <a
                  href="https://webpart.store"
                  target="_blank"
                  class="w-full p-2 rounded hover:bg-gray-200 flex items-center justify-between"
                >
                  <div class="flex items-center">
                    <svg class="fill-current h-5 w-5 mr-2" viewBox="0 0 24 24">
                      <path
                        d="M17.9,17.39C17.64,16.59 16.89,16 16,16H15V13A1,1 0 0,0 14,12H8V10H10A1,1 0 0,0 11,9V7H13A2,2 0 0,0 15,5V4.59C17.93,5.77 20,8.64 20,12C20,14.08 19.2,15.97 17.9,17.39M11,19.93C7.05,19.44 4,16.08 4,12C4,11.38 4.08,10.78 4.21,10.21L9,15V16A2,2 0 0,0 11,18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                      />
                    </svg>
                    <span>Go to website</span>
                  </div>
                  <svg class="fill-current h-4 ml-4" viewBox="0 0 24 24">
                    <path d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z" />
                  </svg>
                </a>
              </div>
              <button
                @click="logout"
                class="border-gray-400 bg-white w-full p-2 border rounded hover:bg-gray-100 inline-flex items-center justify-center hover:shadow"
              >
                <svg class="h-5 w-5 fill-current mr-1" viewBox="0 0 24 24">
                  <path
                    d="M12,17C10.89,17 10,16.1 10,15C10,13.89 10.89,13 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M18,20V10H6V20H18M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V10C4,8.89 4.89,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z"
                  />
                </svg>
                <span>Log Out</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  methods: {
    logout() {
      this.$authService.logout();
    },
    goToProfile() {
      this.showAccountDropdown = false;
      this.$router.push("/profile");
    }
  },
  data() {
    return {
      showNotificationDropdown: false,
      showAccountDropdown: false
    };
  }
};
</script>